import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import OutboundSlider from "./OutboundSlider";
import { SectionContainer } from "../layouts/containers";
import InboundSlider from "./InboundSlider";
import TabLayout from "../layouts/tabLayout";
import { usePlansContext } from "../../context/PlansContext";
import { Divider, Skeleton, Typography } from "antd";
import InboundCardsContainer from "./BundlePlan/inboundCardsContainer";
import OutboundCardsContainer from "./BundlePlan/outboundCardsContainer";
import { INBOUND, OUTBOUND } from "../../utils/constants";
import { fetchAllPlans } from "../../api/fetchAllPlansAPI";

//google tag manager
import { GTM_pageview } from "../../utils/googleTagManager";
import SummaryFooterContainer from "./priceSummary/summaryFooterContainer";
import StepLayout from "../layouts/stepLayout";
import FixedSpinner from "../FixedSpinner";
import { useAppContext } from "../../context/AppContext";

const { Title } = Typography;

const PlanSelection = props => {
    const {
        state: { plans, tabIndex, loading },
        dispatch,
    } = usePlansContext();
    const {
        state: { loading: cartLoading },
    } = useAppContext();

    //load plans data when component loading
    useEffect(() => {
        fetchAllPlans(dispatch);
        //google tag manager
        GTM_pageview("Pricing | MailChannels", "/pricing");
    }, []);

    const InboundSection = (
        <SectionContainer style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
            <Divider>
                <Title level={3} style={{ marginBottom: 0 }}>
                    Inbound Plan
                </Title>
            </Divider>
            {loading ? (
                <Skeleton />
            ) : (
                <>
                    <InboundCardsContainer plans={plans && plans[INBOUND]} />
                    <InboundSlider />
                </>
            )}
        </SectionContainer>
    );

    const OutboundSection = (
        <SectionContainer style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
            <Divider>
                <Title level={3} style={{ marginBottom: 0 }}>
                    Outbound Plan
                </Title>
            </Divider>
            {loading ? (
                <Skeleton />
            ) : (
                <>
                    <OutboundCardsContainer plans={plans && plans[OUTBOUND]} />
                    <OutboundSlider />
                </>
            )}
        </SectionContainer>
    );

    const both = (
        <>
            {OutboundSection}
            {InboundSection}
        </>
    );

    return (
        <StepLayout>
            <Helmet>
                <title>{`Pricing | MailChannels`}</title>
            </Helmet>
            <FixedSpinner loading={Boolean(loading) || Boolean(cartLoading)} size={"large"}>
                <TabLayout currentTab={tabIndex}>
                    {tabIndex === "0" && InboundSection}
                    {tabIndex === "1" && OutboundSection}
                    {tabIndex === "2" && both}
                    <SummaryFooterContainer />
                </TabLayout>
            </FixedSpinner>
        </StepLayout>
    );
};

export default PlanSelection;
